var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.960449,
    y: 0.975891,
    width: 32,
    height: 32,
    fill: "url(#pattern0_2016_1449)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2016_1449",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2016_1449",
    transform: "scale(0.00833333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2016_1449",
    width: 120,
    height: 120,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAACXBIWXMAAAsSAAALEgHS3X78AAAEIklEQVR4nO3a0W3iWBiG4TeruQ9UkEguYNNBKGElCohTwYJcwDIFWGQrGKYAtNPBMhXMbAHWhgqACtgL2xKaBUzMOZh88z1SrjA/1rzxybGZm+12i+n6pesTsLgcWJwDi3NgcQ4szoHFObA4BxbnwOIcWNyHmMOn/eED8C3S+A0wGK/m3yPNLyV5D1gAvzYcuQReW3xCSpG1ed9JogYGXiLOvgUW0/4wXuTT4wLcVT9vNQHSFu87SbQletofpsBjrPmVOvJD8Mlvi3uOJ5J8EGt4lMDT/rBH+Zt5CeEjXy5ubRJrcKwreES75aqtcJEvHxfgkSRPYwy+Cf198LQ/vAf+DTr0dOdtvLqJW1sCDxTZOuTQGJusYxurTcPrTXrA70deb7/x6jYulCveiMDLddAreNofDoC/jxzycbyaT878jBT41HDY267k7uPWNpRX8WuogaH/Bs+OvLY8Ny7AeDWfAc8Nh9VXcq9x4PXEhfK8JyEHBgtcXb3HNlbB7omryB8bDrulDNdkwXXErT2R5MHuCIIFHq/mC8qNwiGjUJ9V7ZZPmXfKL1XMhzFtbGj3RGyv0Et0euS1u2l/ODn3A6q4C8or9Jjn6ko/rshmNC/5l/QScicd4zZpweEnWG120Wug3iz1KP/Oh4m7q7wPbdq8xbakyO5DDoxxm5Ry+D74FvgjwmfuOhy3/Nt2T5F9+d9rRTYjyaHbyGnogcGfZI1X81eaN0CxNMVdAH8dfGrU7XL9lSJbhB4a61HlC+VyfEmnxK2X9k9XGDmNMTRK4PFqvibgrvkEb4lbu6bIf8b6Tjja14XVP/g/sebvaBO3dg2RN7zDb5Nqsa/ic+LWuo48Cv0Fw67gt0k/qp5wxbA++Kz59Li7nqugh+bte+x5X/20V2STs97fIHrgi2sXt3Y48jul9b8qz4sLx5brd0on8Plxa1KRdQLDb5wft5YGmtM5pcC2hwOLc2BxDizOgcU5sDgHFufA4hxYnAOLc2BxDizOgcU5sDgHFufA4hxYnAOLc2BxDizOgcU5sDgHFufA4hxYnAOLc2BxDizOgcU5sDgHFufA4hxYnAOLc2BxDizOgcU5sDgHFufA4hxYnAOLc2BxDizOgcU5sDgHFufA4hxYnFLgQdcncI2UAtseDizOgcU5sDgHFufA4hxYnAOLc+D9Fl2fQCgOLM6BxTmwOAcW58DiHFicA4tzYHEOLM6BxTmwOKXArwFnrQPO6tTNdrvt+hzCSfIBMAPuWk5YAilFtgh0Rp3TClxL8hEwAW5PfMcGmFBkL9HOqSOagQGSvAe8AE8NR34GRhSZzLK8SzdwLckfKEM//vDKV8qw3y9/UpejH7iW5Cnlsg1l2C/dnczl/DyBf1JKt0m2hwOLc2BxDizOgcU5sDgHFufA4v4DiA0kqDUDYcgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrice);
export default __webpack_public_path__ + "static/media/trice.ebb10bf0fbbcaa3634a04968b71b87e2.svg";
export { ForwardRef as ReactComponent };